if (typeof window.initProductMediaGallery !== "function") {
  window.initProductMediaGallery = function initProductMediaGallery(section) {
    const allowedSections = ["product-section", "featured-product-section"];

    if (
      !section ||
      !allowedSections.some((cls) => section.classList.contains(cls))
    ) {
      return;
    }

    const initMainSlider = (section) => {
      if (
        !section ||
        !allowedSections.some((cls) => section.classList.contains(cls))
      ) {
        return;
      }

      const sliderEl = section.querySelector(".js-media-list");
      if (!sliderEl) return;

      const desktopType = sliderEl.dataset?.desktopType || "slider_previews";
      const mobileType = sliderEl.dataset?.mobileType || "slider_previews";
      const hasDesktopZoom = sliderEl.dataset?.hasDesktopZoom === "true";
      const mediaBox = sliderEl.closest(".product__media");
      const thumbsSlider = mediaBox?.querySelector(".js-media-sublist");
      const buttonPrev =
        mediaBox?.querySelector(
          ".product__media-sublist-wrapper .slider-nav-button--prev"
        ) ?? sliderEl.querySelector(".slider-nav-button--prev");
      const buttonNext =
        mediaBox?.querySelector(
          ".product__media-sublist-wrapper .slider-nav-button--next"
        ) ?? sliderEl.querySelector(".slider-nav-button--next");
      const paginationEl = sliderEl.querySelector(".slider-pagination");

      const isLoop = sliderEl.querySelectorAll(".swiper-slide").length > 1;

      const initSwiper = () => {
        new Swiper(sliderEl, {
          slidesPerView: 1,
          spaceBetween: 16,
          autoHeight: false,
          loop: false,
          direction: "horizontal",
          speed: 800,
          allowTouchMove: true,
          watchSlidesProgress: true,
          mousewheel: {
            forceToAxis: true,
          },
          navigation: {
            nextEl: buttonNext,
            prevEl: buttonPrev,
          },
          pagination: {
            el: paginationEl,
            clickable: true,
          },
          breakpoints: {
            990: {
              allowTouchMove: !hasDesktopZoom,
            },
          },
          thumbs: {
            swiper: thumbsSlider?.swiper ? thumbsSlider.swiper : "",
            //autoScrollOffset: 1,
            multipleActiveThumbs: false,
            slideThumbActiveClass: "swiper-slide-thumb-active",
          },
          on: {
            slideChange: function () {
              window.pauseAllMedia(sliderEl);
              this.params.noSwiping = false;

              if (thumbsSlider?.swiper) {
                const activeIndex = isLoop ? this.realIndex : this.activeIndex;
                thumbsSlider.swiper.slideTo(activeIndex);
              }
            },
            slideChangeTransitionEnd: function () {
              const activeIndex = isLoop ? this.realIndex : this.activeIndex;
              const model3D =
                this.slides[activeIndex]?.querySelector("model-viewer");
              const posterBtn3D = this.slides[activeIndex]?.querySelector(
                ".shopify-model-viewer-ui__button--poster"
              );
              if (model3D && posterBtn3D) {
                posterBtn3D.removeAttribute("hidden");
              }
            },
            touchStart: function () {
              const activeIndex = isLoop ? this.realIndex : this.activeIndex;
              const model3D =
                this.slides[activeIndex]?.querySelector("model-viewer");
              if (model3D) {
                if (
                  !model3D.classList.contains(
                    "shopify-model-viewer-ui__disabled"
                  )
                ) {
                  this.params.noSwiping = true;
                  this.params.noSwipingClass = "swiper-slide";
                } else {
                  this.params.noSwiping = false;
                }
              }
            },
          },
        });
      };

      const destroySwiper = () => {
        if (sliderEl.swiper) {
          sliderEl.swiper.destroy();
        }
        sliderEl.querySelectorAll(".swiper-wrapper").forEach((wrapper) => {
          wrapper.removeAttribute("style");
        });
        sliderEl.querySelectorAll(".swiper-slide").forEach((slide) => {
          slide.removeAttribute("style");
        });
      };

      const hasDesktopSwiper =
        desktopType === "slider" || desktopType == "slider_previews";
      const hasMobileSwiper =
        mobileType === "slider" || mobileType == "slider_previews";

      if (section._mainSliderResizeObserver) {
        section._mainSliderResizeObserver.disconnect();
        section._mainSliderResizeObserver = null;
      }

      if (hasDesktopSwiper && hasMobileSwiper) {
        initSwiper();
      } else {
        const resizeObserver = new ResizeObserver((entries) => {
          entries.forEach((entry) => {
            if (window.innerWidth >= 990 && hasDesktopSwiper) {
              initSwiper();
              return;
            }

            if (window.innerWidth < 990 && hasMobileSwiper) {
              initSwiper();
              return;
            }

            destroySwiper();
          });
        });

        resizeObserver.observe(section);
        section._mainSliderResizeObserver = resizeObserver;
      }
    };

    const initSubSlider = (section) => {
      if (
        !section ||
        !allowedSections.some((cls) => section.classList.contains(cls))
      ) {
        return;
      }

      const sliderEl = section.querySelector(".js-media-sublist");
      if (!sliderEl) return;

      if (!sliderEl.dataset.focusSelectBound) {
        sliderEl.dataset.focusSelectBound = "true";
        sliderEl.addEventListener("focusin", (event) => {
          const subitem = event.target.closest(".product__media-subitem");
          if (!subitem) return;

          const mainSliderEl = section.querySelector(".js-media-list");
          if (!mainSliderEl?.swiper) return;

          const index = Array.from(
            sliderEl.querySelectorAll(".product__media-subitem")
          ).indexOf(subitem);
          if (index === -1) return;

          mainSliderEl.swiper.slideTo(index);
        });
      }

      const desktopType = sliderEl.dataset?.desktopType || "slider_previews";
      const mobileType = sliderEl.dataset?.mobileType || "slider_previews";
      const hasDesktopSwiper = desktopType === "slider_previews";
      const hasMobileSwiper = mobileType === "slider_previews";

      const initSwiper = () => {
        const thumbSlider = new Swiper(sliderEl, {
          spaceBetween: 16,
          slidesPerView: "auto",
          loop: false,
          direction: "horizontal",
          allowTouchMove: true,
          watchSlidesProgress: true,
          watchOverflow: true,
          observer: true,
          observeParents: true,
          autoHeight: false,
          slideToClickedSlide: true,
          freeMode: {
            enabled: true,
            sticky: false,
            momentum: true,
          },
          on: {
            touchEnd: function (swiper) {
              let range = 5;
              let diff = (swiper.touches.diff = swiper.isHorizontal()
                ? swiper.touches.currentX - swiper.touches.startX
                : swiper.touches.currentY - swiper.touches.startY);
              if (diff < range && diff > -range) swiper.allowClick = true;
            },
          },
          breakpoints: {
            576: {
              slidesPerView: "auto",
            },
            990: {
              slidesPerView: "auto",
              direction: "vertical",
            },
          },
        });

        return thumbSlider;
      };

      if (section._subSliderResizeObserver) {
        section._subSliderResizeObserver.disconnect();
        section._subSliderResizeObserver = null;
      }

      if (hasDesktopSwiper || hasMobileSwiper) {
        initSwiper();

        const resizeObserver = new ResizeObserver((entries) => {
          entries.forEach((entry) => {
            if (sliderEl.swiper) {
              if (window.innerWidth >= 990 && hasDesktopSwiper) {
                sliderEl.swiper.enable();
                sliderEl.swiper.changeDirection("vertical", true);
              }

              if (window.innerWidth < 990 && hasMobileSwiper) {
                sliderEl.swiper.enable();
                sliderEl.swiper.changeDirection("horizontal", true);
              }
            }
          });
        });

        resizeObserver.observe(section);
        section._subSliderResizeObserver = resizeObserver;
      }
    };

    const initZoomSlider = (section) => {
      if (
        !section ||
        !allowedSections.some((cls) => section.classList.contains(cls))
      ) {
        return;
      }

      const sectionBox =
        section.querySelector('[id^="MainProduct-"]') ||
        section.querySelector('[id^="FeaturedProduct-"]');
      const sectionId = sectionBox?.dataset?.section;
      const sliderEl = document.querySelector(
        `[data-section-id='${sectionId}'].js-popup-slider`
      );
      if (!sliderEl) return;

      const buttonPrev = sliderEl.querySelector(".slider-nav-button--prev");
      const buttonNext = sliderEl.querySelector(".slider-nav-button--next");
      const paginationEl = sliderEl.querySelector(".slider-pagination");

      const isLoop = sliderEl.querySelectorAll(".swiper-slide").length > 1;

      const onMainSliderToggleClick = (event) => {
        if (!sliderEl.swiper) return;
        const zoomToggle = event.target.closest(".product__media-toggle");
        if (!zoomToggle) return;
        const mediaId = zoomToggle.dataset?.mediaId;
        if (!mediaId) return;
        sliderEl
          .querySelectorAll(".product-media-modal__item.swiper-slide")
          .forEach((slide, index) => {
            const zoomImageEl = slide.querySelector(
              `[data-media-id="${mediaId}"]`
            );
            if (zoomImageEl) {
              const findIndex = sliderEl.swiper.slides.findIndex(
                (slideEl) => slideEl.dataset?.mediaId === mediaId
              );
              const fallbackIndex = Number(
                slide.dataset?.swiperSlideIndex || index
              );
              const slideIndex = findIndex !== -1 ? findIndex : fallbackIndex;
              sliderEl.swiper.slideTo(slideIndex, 0);
              sliderEl.swiper.update();
            }
          });
      };

      new Swiper(sliderEl, {
        slidesPerView: 1,
        speed: 800,
        loop: isLoop,
        zoom: {
          maxRatio: 2,
        },
        mousewheel: {
          forceToAxis: true,
        },
        navigation: {
          nextEl: buttonNext,
          prevEl: buttonPrev,
        },
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        on: {
          afterInit: function () {
            section
              .querySelectorAll(".product__media-list .product__media-toggle")
              .forEach((elem) => {
                elem.addEventListener("click", onMainSliderToggleClick);
              });
          },
          slideChange: function () {
            window.pauseAllMedia(sliderEl);
            this.params.noSwiping = false;
            sliderEl.classList.remove("zoom");
          },
          touchMove: function () {
            sliderEl.classList.remove("zoom");
          },
          slideChangeTransitionEnd: function () {
            const activeIndex = isLoop ? this.realIndex : this.activeIndex;
            const model3D =
              this.slides[activeIndex]?.querySelector("model-viewer");
            const posterBtn3D = this.slides[activeIndex]?.querySelector(
              ".shopify-model-viewer-ui__button--poster"
            );
            if (model3D && posterBtn3D) {
              posterBtn3D.removeAttribute("hidden");
            }
          },
          touchStart: function () {
            const activeIndex = isLoop ? this.realIndex : this.activeIndex;
            const model3D =
              this.slides[activeIndex]?.querySelector("model-viewer");
            if (model3D) {
              if (
                !model3D.classList.contains("shopify-model-viewer-ui__disabled")
              ) {
                this.params.noSwiping = true;
                this.params.noSwipingClass = "swiper-slide";
              } else {
                this.params.noSwiping = false;
              }
            }
          },
        },
      });
    };

    const initCustomCursor = (section) => {
      const mediaList = section.querySelector(".product__media-list");
      const isInlineZoom = mediaList?.dataset?.desktopZoomType === "inline";

      let cursor = document.querySelector(".product__media-cursor");
      if (!cursor) {
        cursor = document.createElement("div");
        cursor.className = "product__media-cursor";
        document.body.appendChild(cursor);
      }

      section.querySelectorAll(".product__media-toggle").forEach((toggle) => {
        let isZoomed = false;

        const getImgContainer = () =>
          toggle
            .closest(".product__modal-opener, .product__media-item")
            ?.querySelector(".product__media-img");

        const getImg = () => getImgContainer()?.querySelector("img");

        const getMediaItem = () => toggle.closest(".product__media-item");

        toggle.addEventListener("mouseenter", () => {
          if (window.innerWidth < 990) return;
          cursor.classList.add("product__media-cursor--active");
        });

        toggle.addEventListener("mouseleave", () => {
          cursor.classList.remove("product__media-cursor--active");
        });

        if (window.innerWidth >= 990 && toggle.matches(":hover")) {
          cursor.classList.add("product__media-cursor--active");
        }

        toggle.addEventListener("mousemove", (e) => {
          if (window.innerWidth < 990) return;
          cursor.classList.add("product__media-cursor--active");
          cursor.style.left = e.clientX + "px";
          cursor.style.top = e.clientY + "px";

          if (isInlineZoom && isZoomed) {
            const imgContainer = getImgContainer();
            const img = getImg();
            if (!img || !imgContainer) return;
            const rect = imgContainer.getBoundingClientRect();
            const rx = (((e.clientX - rect.left) / rect.width) * 100).toFixed(
              2
            );
            const ry = (((e.clientY - rect.top) / rect.height) * 100).toFixed(
              2
            );
            img.style.transformOrigin = `${rx}% ${ry}%`;
          }
        });

        if (isInlineZoom) {
          toggle.addEventListener("click", (e) => {
            if (window.innerWidth < 990) return;
            e.preventDefault();
            e.stopPropagation();

            const img = getImg();
            const imgContainer = getImgContainer();
            const mediaItem = getMediaItem();
            if (!img || !mediaItem) return;

            isZoomed = !isZoomed;

            if (isZoomed) {
              const rect = imgContainer?.getBoundingClientRect();
              if (rect) {
                const rx = (
                  ((e.clientX - rect.left) / rect.width) *
                  100
                ).toFixed(2);
                const ry = (
                  ((e.clientY - rect.top) / rect.height) *
                  100
                ).toFixed(2);
                img.style.transformOrigin = `${rx}% ${ry}%`;
              }
              img.style.transform = "scale(2)";
              mediaItem.classList.add("product__media-item--inline-zoomed");
              cursor.classList.add("product__media-cursor--zoomed");
            } else {
              img.style.transform = "";
              img.style.transformOrigin = "";
              mediaItem.classList.remove("product__media-item--inline-zoomed");
              cursor.classList.remove("product__media-cursor--zoomed");
            }
          });
        }
      });

      if (isInlineZoom) {
        const resetZoom = () => {
          section
            .querySelectorAll(".product__media-item--inline-zoomed")
            .forEach((item) => {
              item.classList.remove("product__media-item--inline-zoomed");
              const img = item.querySelector("img");
              if (img) {
                img.style.transform = "";
                img.style.transformOrigin = "";
              }
            });
          cursor?.classList.remove("product__media-cursor--zoomed");
        };

        const sliderEl = section.querySelector(".js-media-list");
        if (sliderEl?.swiper) {
          sliderEl.swiper.on("slideChange", resetZoom);
        }
      }
    };

    initSubSlider(section);
    initMainSlider(section);
    initZoomSlider(section);
    initCustomCursor(section);

    document.addEventListener("shopify:section:load", (event) => {
      initSubSlider(event.target);
      initMainSlider(event.target);
      initZoomSlider(event.target);
      initCustomCursor(event.target);
    });
  };
}

if (typeof window.initProductPageElements !== "function") {
  window.initProductPageElements = function initProductPageElements(section) {
    const allowedSections = ["product-section", "featured-product-section"];

    if (
      !section ||
      !allowedSections.some((cls) => section.classList.contains(cls))
    ) {
      return;
    }

    const initProductAccordion = (section) => {
      if (
        !section ||
        !allowedSections.some((cls) => section.classList.contains(cls))
      ) {
        return;
      }

      section.querySelectorAll(".product-accordion").forEach((details) => {
        const summary = details.querySelector(".product-accordion__toggle");
        const content = details.querySelector(".product-accordion__content");
        let isAnimating = false;

        if (!summary || !content) return;

        summary.addEventListener("click", (event) => {
          if (isAnimating) return;

          event.preventDefault();

          isAnimating = true;

          if (!details.getAttribute("open")) {
            section
              .querySelectorAll(".product-accordion[open]")
              .forEach((otherDetails) => {
                if (otherDetails === details) return;
                otherDetails.removeAttribute("open");
              });

            const contentHeight = content.scrollHeight;
            content.style.setProperty(
              "--product-accordion-max-height",
              `${contentHeight}px`
            );

            details.setAttribute("open", true);

            content.addEventListener(
              "transitionend",
              () => {
                isAnimating = false;
              },
              { once: true }
            );
          } else {
            details.removeAttribute("open");

            content.addEventListener(
              "transitionend",
              () => {
                isAnimating = false;
              },
              { once: true }
            );
          }
        });
      });
    };

    const initStickyAddBar = (section) => {
      if (!section || !section.classList.contains("product-section")) {
        return;
      }

      const buyButtons =
        section.querySelector(".product__buy-buttons > product-form") ||
        section.querySelector(".product__buy-buttons");
      const stickyBar = section.querySelector(".product-sticky-add-bar");
      const footerEl =
        document.querySelector("footer.shopify-section-footer") ||
        document.querySelector(".shopify-section-footer") ||
        document.querySelector("footer");

      if (!stickyBar || stickyBar.dataset.stickyInit === "true") return;
      stickyBar.dataset.stickyInit = "true";

      let buyButtonsInView = true;
      let footerInView = false;
      let buyButtonsObserver;
      let footerObserver;

      const getHeaderHeight = () => {
        const val = getComputedStyle(document.documentElement)
          .getPropertyValue("--header-height")
          .trim();
        return parseFloat(val) || 0;
      };

      const getStickyZone = () => {
        const bottom = parseFloat(getComputedStyle(stickyBar).bottom) || 0;
        return Math.max(stickyBar.offsetHeight + bottom + 16, 80);
      };

      const isBuyButtonsBelow = () => {
        if (!buyButtons) return false;
        return buyButtons.getBoundingClientRect().top > getHeaderHeight();
      };

      const updateStickyBar = () => {
        const shouldShow =
          Boolean(buyButtons) &&
          !buyButtonsInView &&
          !footerInView &&
          !isBuyButtonsBelow();
        stickyBar.classList.toggle("active", shouldShow);
      };

      const observeTargets = () => {
        if (buyButtonsObserver) buyButtonsObserver.disconnect();
        if (footerObserver) footerObserver.disconnect();

        buyButtonsObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              buyButtonsInView = entry.isIntersecting;
            });
            updateStickyBar();
          },
          {
            root: null,
            rootMargin: `-${getHeaderHeight()}px 0px 0px 0px`,
            threshold: 0,
          }
        );

        footerObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              footerInView = entry.isIntersecting;
            });
            updateStickyBar();
          },
          {
            root: null,
            rootMargin: `0px 0px ${getStickyZone()}px 0px`,
            threshold: 0,
          }
        );

        if (buyButtons) buyButtonsObserver.observe(buyButtons);
        if (footerEl) footerObserver.observe(footerEl);
        updateStickyBar();
      };

      observeTargets();

      const headerEl = document.querySelector(".shopify-section-header");
      if (headerEl) {
        new ResizeObserver(observeTargets).observe(headerEl);
      }

      const scrollToOptions = () => {
        const optionsTarget =
          section.querySelector(".product-parameters") ||
          section.querySelector(".product__buy-buttons");
        if (!optionsTarget) return;
        const top =
          optionsTarget.getBoundingClientRect().top +
          window.scrollY -
          getHeaderHeight() -
          16;
        window.scrollTo({ top: Math.max(top, 0), behavior: "smooth" });
      };

      const viewOptionsBtn = stickyBar.querySelector(
        "[data-scroll-to-options]"
      );
      if (viewOptionsBtn) {
        viewOptionsBtn.addEventListener("click", scrollToOptions);
      }

      stickyBar.addEventListener("click", (event) => {
        if (
          event.target.closest(
            "button, a, product-form, form, input, label, [data-scroll-to-options]"
          )
        ) {
          return;
        }
        scrollToOptions();
      });
    };

    initStickyAddBar(section);
    initProductAccordion(section);

    document.addEventListener("shopify:section:load", (event) => {
      initStickyAddBar(event.target);
      if (!window.Shopify.designMode) {
        initProductAccordion(event.target);
      }
    });
  };
}

window.initProductMediaGallery(document.currentScript.parentElement);

if (!window.__productDescriptionToggleBound) {
  window.__productDescriptionToggleBound = true;

  document.addEventListener("click", (event) => {
    const toggle = event.target.closest(".product__description__toggle");
    if (!toggle) return;

    const description = toggle.closest(".product__description");
    const preview = description.querySelector(".product__description__preview");
    const full = description.querySelector(".product__description__full");
    const isExpanded = toggle.getAttribute("aria-expanded") === "true";

    const toggleLabel = toggle.querySelector("span") || toggle;
    if (isExpanded) {
      toggle.setAttribute("aria-expanded", "false");
      toggleLabel.textContent = toggle.dataset.showLabel;
      full.hidden = true;
      preview.hidden = false;
      preview.removeAttribute("aria-hidden");
    } else {
      toggle.setAttribute("aria-expanded", "true");
      toggleLabel.textContent = toggle.dataset.hideLabel;
      preview.hidden = true;
      full.hidden = false;
    }
  });
}
window.initProductPageElements(document.currentScript.parentElement);
